export const PC_BENEFITS_BUTTON_TEXT = "Premier Collection Benefits";
export const LC_BENEFITS_BUTTON_TEXT = "Lifestyle Collection Benefits";
